/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
var noop = function noop() {
  return undefined;
};
noop.noop = true;
export default noop;